import {groupArrayByKey, uniqueObjectWithKey} from '@coolcolduk/util';
import {ModuleTopic} from '@cp/model';

/**
 * convert ModuleTopic array to Record<category, ModuleTopic[]>
 * @param moduleTopics module topic array
 * @returns Record<category, ModuleTopic[]>
 */
export default function mapModuleTopicsArrayToRecordModuleTopicsByCategory(
  moduleTopics: ModuleTopic[],
): Record<string, ModuleTopic[]> {
  const uniqueModuleTopics = uniqueObjectWithKey(moduleTopics, 'topic');
  return groupArrayByKey(uniqueModuleTopics, 'category');
}
